import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import MessageErrorComponent from '@/views/components/message-error/index.component'

type Props = {
  children: React.ReactNode
}

const ErrorLimit = ({ children }: Props) => {
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <MessageErrorComponent message={error.message} runtimeError />
      )}
    >
      {children}
    </ErrorBoundary>
  )
}

export default ErrorLimit
